@if (shouldShowUpdate && meta.versionMismatch()) {
  <button
    class="btn btn-neutral btn-xs ms-3"
    appButtonGlow
    (click)="meta.update()"
    appAnalyticsClick="Meta:Update:Click"
    appSfx="ui-click"
    [sfxTrigger]="['click', 'hover']"
  >
    Update Available ({{ meta.liveVersionString() }})
  </button>
}
